import { Grid, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

export interface LetterOfSupportInfoProps {}

export function LetterOfSupportInfo({}: LetterOfSupportInfoProps) {
  return (
    <>
      <Typography variant="body1" my={2}>
        Your letter of support must cover all four of these:
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1">
            <CheckIcon color="primary" fontSize="inherit" sx={{ mr: 1 }} /> The
            professional's credentials
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1">
            <CheckIcon color="primary" fontSize="inherit" sx={{ mr: 1 }} /> How
            they know your child
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1">
            <CheckIcon color="primary" fontSize="inherit" sx={{ mr: 1 }} /> The
            diagnosis or need clearly described
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1">
            <CheckIcon color="primary" fontSize="inherit" sx={{ mr: 1 }} /> Why
            this item or service will meet that need
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
